var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center justify-space-between",attrs:{"id":"auth_header"}},[_c('div',[(_vm.brand_logo)?_c('img',{staticClass:"auth-brand-logo pt-0 mt-0 pl-0 ml-0",attrs:{"src":_vm.brand_logo,"alt":"Logo"}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }